var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainBackgroundRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 499,
    height: 881,
    viewBox: "0 0 499 881",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    filter: "url(#filter0_f_64_275)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 317,
    width: 128,
    height: 210,
    rx: 25,
    fill: "#E4E7ED"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 297,
    width: 168,
    height: 190,
    rx: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    filter: "url(#filter1_f_64_275)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 277,
    width: 128,
    height: 210,
    rx: 25,
    fill: "#E4E7ED"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 257,
    width: 168,
    height: 190,
    rx: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    filter: "url(#filter2_f_64_275)"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 483,
    y: 317,
    width: 128,
    height: 210,
    rx: 25,
    fill: "#E4E7ED"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 463,
    y: 297,
    width: 168,
    height: 190,
    rx: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    filter: "url(#filter3_f_64_275)"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 483,
    y: 87,
    width: 128,
    height: 210,
    rx: 25,
    fill: "#E4E7ED"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 463,
    y: 67,
    width: 168,
    height: 190,
    rx: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    filter: "url(#filter4_f_64_275)"
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 507,
    width: 128,
    height: 210,
    rx: 25,
    fill: "#E4E7ED"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    filter: "url(#filter5_f_64_275)"
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 737,
    width: 128,
    height: 210,
    rx: 25,
    fill: "#E4E7ED"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    filter: "url(#filter6_f_64_275)"
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 559,
    width: 128,
    height: 210,
    rx: 25,
    fill: "#E4E7ED"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    filter: "url(#filter7_f_64_275)"
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 559,
    width: 128,
    height: 210,
    rx: 25,
    fill: "#E4E7ED"
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 487,
    width: 168,
    height: 190,
    rx: 25,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 717,
    width: 168,
    height: 190,
    rx: 25,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 539,
    width: 168,
    height: 190,
    rx: 25,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 453,
    y: 539,
    width: 168,
    height: 190,
    rx: 25,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_64_275",
    x: 0.0149841,
    y: 230.015,
    width: 301.97,
    height: 383.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 43.4925,
    result: "effect1_foregroundBlur_64_275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_64_275",
    x: 198.015,
    y: 190.015,
    width: 301.97,
    height: 383.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 43.4925,
    result: "effect1_foregroundBlur_64_275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_64_275",
    x: 396.015,
    y: 230.015,
    width: 301.97,
    height: 383.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 43.4925,
    result: "effect1_foregroundBlur_64_275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_64_275",
    x: 396.015,
    y: 0.0149841,
    width: 301.97,
    height: 383.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 43.4925,
    result: "effect1_foregroundBlur_64_275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_64_275",
    x: 198.015,
    y: 420.015,
    width: 301.97,
    height: 383.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 43.4925,
    result: "effect1_foregroundBlur_64_275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_64_275",
    x: 198.015,
    y: 650.015,
    width: 301.97,
    height: 383.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 43.4925,
    result: "effect1_foregroundBlur_64_275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_64_275",
    x: 0.0149841,
    y: 472.015,
    width: 301.97,
    height: 383.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 43.4925,
    result: "effect1_foregroundBlur_64_275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_64_275",
    x: 386.015,
    y: 472.015,
    width: 301.97,
    height: 383.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 43.4925,
    result: "effect1_foregroundBlur_64_275"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainBackgroundRight);
export default __webpack_public_path__ + "static/media/mainBackgroundRight.238d7cd0cb6a5f5f2dc1c01e89d0c4de.svg";
export { ForwardRef as ReactComponent };